import { Component, Input, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { JobService } from '../../../service/job.service';
import { JobRepairApplyComponent } from '../../../job/job-manager/job-repair-apply/job-repair-apply.component';

@Component({
  selector: 'app-state-alarm-detail',
  templateUrl: './state-alarm-detail.component.html',
  styleUrls: ['./state-alarm-detail.component.less']
})
export class StateAlarmDetailComponent implements OnInit {

  constructor(
    private modalService: NzModalService,
    private jobService: JobService,
    public message: NzMessageService,
  ) { }

  @Input() stateAndAlarm: any;
  @Input() equipmentNo: any;
  @Input() equipmentName: any;

  listBmsState = [];
  listHspAlarm = [];
  pageSize = 3;

  ngOnInit(): void {
    const myBimDiv = document.getElementById('state-alarm-table') as HTMLDivElement;
    if (this.stateAndAlarm.bmsState != null) {
      const listBms = this.stateAndAlarm.bmsState;
      if (listBms !== null) {
        listBms.forEach(element => {
          const newJson = JSON.parse(element.state);
          newJson.time = this.currentDateFormat(new Date(element.updateTime));
          this.listBmsState.push(newJson);
        });
      }
    }
    if (this.stateAndAlarm.hspAlarm != null) {
      this.listHspAlarm = this.stateAndAlarm.hspAlarm;
    }
    // myBimDiv.innerHTML = this.showProperties(this.listBmsState, this.listHspAlarm);
  }

  showProperties(stateList: any, alarmList: any): string {
    let html = null;
    // tslint:disable-next-line: max-line-length
    html = '<div style="width:480px;overflow-y:auto;background:#FFF">';
    html += '<table border="1">';
    // tslint:disable-next-line: prefer-const
    for (let [index, item] of stateList.entries()) {
      if (index === 0) {
        html += '<tr><th style="height:30px;width:480px">物资状态</th></tr>';
      }
      html += '<tr><td>' + item.desc + '(' + item.type + '):&nbsp;&nbsp;&nbsp;' + item.value + item.unit + '</td></tr>';
    }
    html += '</table>';
    html += '</div>';
    html += '<div style="width:480px;overflow-y:auto;background:#FFF;margin-top:10px">';
    html += '<table border="1">';
    for (const [index, item] of alarmList.entries()) {
      if (index === 0) {
        html += '<tr><th style="height:30px;width:150px">警报信息</th><th style="height:30px;width:330px"></th></tr>';
      }
      html += '<tr><td>' + '警报名称' + '</td><td>' + item.eventName + '<a style="float:right;margin-right:17px">报修</a></td></tr>';
      html += '<tr><td>' + '警报类型' + '</td><td>' + item.srcType + '</td></tr>';
      html += '<tr><td>' + '警报级别' + '</td><td>' + item.eventLevel + '</td></tr>';
      html += '<tr><td>' + '警报来源' + '</td><td>' + item.srcName + '</td></tr>';
      html += '<tr><td>' + '警报状态' + '</td><td>' + item.statusStr + '</td></tr>';
      html += '<tr><td>' + '警报区域' + '</td><td>' + item.regionName + '</td></tr>';
      html += '<tr><td>' + '警报位置' + '</td><td>' + item.address + '</td></tr>';
      html += '<tr><td>' + '报警时间' + '</td><td>' + item.happenTimeStr + '</td></tr>';
    }
    html += '</table>';
    html += '</div>';
    return html;
  }

  checkEmpty(obj: any) {
    return this.isEmpty(obj) ? '' : obj;
  }

  currentDateFormat(date, format: string = 'yyyy-mm-dd HH:MM'): any {
    if (!this.isEmpty(date)){
      const pad = (n: number): string => (n < 10 ? `0${n}` : n.toString());
      return format
        .replace('yyyy', date.getFullYear())
        .replace('mm', pad(date.getMonth() + 1))
        .replace('dd', pad(date.getDate()))
        .replace('HH', pad(date.getHours()))
        .replace('MM', pad(date.getMinutes()))
        .replace('ss', pad(date.getSeconds()));
    }else{
      return null;
    }
  }

  async report(data: any) {
    // 根据警报编号检查该警报是否已报修
    if (await this.jobService.getJobByAlarmId(data.alarmId) > 0) {
      this.message.create('warning', '该警报已经存在上报的工单！');
    }
    const alarmMsg = '名称:' + data.eventName
                      + ',类型:' + data.srcType
                      + ',状态:' + data.statusStr
                      + ',级别:' + data.eventLevel
                      + ',编号:' + data.alarmId
                      + ',来源:' + data.srcName
                      + ',时间:' + data.happenTimeStr;
    const modal = this.modalService.create({
      nzTitle: '报修',
      nzContent: JobRepairApplyComponent,
      nzStyle: { top: '20px' },
      nzWidth: 450,
      nzFooter: null,
      nzComponentParams: {
        pageFlag: 'alarm',
        equipmentNo: this.equipmentNo,
        equipmentName: this.equipmentName,
        alarmMsg
      },
    });
  }

  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }

}
